import { call, put } from 'redux-saga/effects';
import request from 'utils/request';

const createBaseRequest = (type, urlMethod) => {
  return function* baseRequest({ payload }) {
    yield put({ type: `${type}_FETCH`, payload });
    try {
      const res = yield call(request, ...urlMethod(payload));
      if (res.result === 'ok' || res.success) {
        yield put({ type: `${type}_SUCCESS`, payload: res.data, request: payload, response: res });
      } else {
        const error = new Error(`Result is ${res.result}`);
        error.response = res;
        error.code = res.code;
        console.log(error);
        yield put({ type: `${type}_ERROR`, payload: error, request: payload });
      }
    } catch (error) {
      console.log(error);
      yield put({ type: `${type}_ERROR`, payload: error, request: payload });
    }
  };
};

export default createBaseRequest;
